import { labelModes, services } from '@/utils'

import selectorOwner from '@/components/selector/owner'

function renderSelectorOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        labelMode: labelModes.hidden,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}

export default function(h) {
  if (this.checkPermissions(`advanced.${services.users}.get`)) {
    return h(
      'div',
      {
        class: 'grid grid-gap--8',
        style: { gridTemplateColumns: '250px' }
      },
      [ renderSelectorOwner.call(this, h) ]
    )
  }
}
